/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { TabbedContentImageItemFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";
import { ContentLargeImageMedia } from "../content-large-image/ContentLargeImage.Media";
import { Flex, VStack } from "@panda/jsx";
import { CosmosButtonProps, CosmosTextVariantEnum } from "@components/elements/atoms";
import { ColorfulTitle } from "@components/elements/molecules/title-desc-stack/ColorfulTitle.molecule";
import { CosmosDesc } from "@components/elements/molecules/title-desc-stack";
import { ButtonList } from "@components/elements/molecules/button-list";

const styled = css({
	lgDown: {
		flexDirection: "column",
		gap: "eds.dimension.64",
	},
	smDown: {
		gap: "eds.dimension.48",
	},
});

const stackStyles = css({
	flex: "50%",
	maxWidth: "50%",
	lgDown: {
		maxWidth: "100%",
	},

	"& .title": {
		flexBasis: "60%",
		marginBottom: "eds.dimension.32",
		smDown: {
			marginBottom: "eds.dimension.16",
		},
	},

	"& .desc-buttons": {
		lgDown: {
			gap: "eds.dimension.24",
		},
	},

	"& .cosmos-text.heading": {
		lgDown: {
			textStyle: "headingMD",
		},
	},

	"& .cosmos-text.paragraph": {
		xxlDown: {
			textStyle: "paragraphSM",
		},
	},

	"& .button-list": {
		xsOnly: {
			flexDirection: "column",
			alignItems: "flex-start",
		},
	},
});

export interface TabbedContentImageContentProps extends TabbedContentImageItemFragment {
	singleTab?: boolean;
}

export const TabbedContentImageContent = (props: TabbedContentImageContentProps): React.JSX.Element => {
	const cleanTitleHtml = props.title?.html.replace(/^<br \/>/, "").replace(/^<br\/>/, "");
	const titleValid = props.title?.text && cleanTitleHtml;

	const cosmosButtons = (props.buttons || []).map((button): CosmosButtonProps => {
		return {
			...button,
			size: "lg",
		};
	});

	return (
		<Flex
			direction={props?.flip ? "row-reverse" : "row"}
			justifyContent="space-between"
			gap="eds.dimension.40"
			className={styled}
		>
			<VStack
				gap="eds.dimension.16"
				alignItems="flex-start"
				className={stackStyles}
				justifyContent={props.singleTab ? "center" : "flex-start"}
			>
				{titleValid ? (
					<ColorfulTitle
						gradient={props.gradient}
						title={{
							...props.title,
							as: "h3",
							html: cleanTitleHtml,
							variant: CosmosTextVariantEnum.headingXL,
							color: "eds.text.primary",
						}}
					/>
				) : null}
				<VStack className="desc-buttons" gap="eds.dimension.24" alignItems="flex-start">
					{props.desc ? (
						<CosmosDesc
							description={{
								html: props.desc,
								variant: CosmosTextVariantEnum.paragraphMD,
								color: "eds.text.primary",
							}}
						/>
					) : (
						""
					)}
					<ButtonList buttons={cosmosButtons} />
				</VStack>
			</VStack>

			<div
				className={cx(
					css({
						w: "1/2",
						aspectRatio: "16 / 9",
						lgDown: {
							w: "full",
						},
					}),
				)}
			>
				<ContentLargeImageMedia
					asset={props?.asset}
					blurredImage={props?.blurredImage}
					className={css({
						"& .cosmos-asset": {
							borderRadius: "eds.borderRadius.16",
						},
					})}
				/>
			</div>
		</Flex>
	);
};
